import { render, staticRenderFns } from "./SystemSpecifications.vue?vue&type=template&id=0abfa604&scoped=true"
import script from "./SystemSpecifications.vue?vue&type=script&lang=js"
export * from "./SystemSpecifications.vue?vue&type=script&lang=js"
import style0 from "./SystemSpecifications.vue?vue&type=style&index=0&id=0abfa604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abfa604",
  null
  
)

export default component.exports